import { FolderApi } from "certiblok-api-manager";
import { TreeViewProvider } from "../../../controllers/TreeViewController/TreeViewController";
import { TreeViewListItemType } from "../../../controllers/TreeViewController/types/ListItem";
import { instanceApi } from "../../../hooks/api";
import { transformToStringFrom, defaultQueryFilter } from "../../tables/AdminTable";
import TreeViewList from "../../TreeViewList/TreeViewList";
import { PickerListItem } from "./PickerListItem";
import DocumentPreviewModal from "../../../../pages/EditRooms/pages/EditRoom/components/DocumentPreviewModal";

export function TreeViewDocumentPickerList() {
	return (
		<>
			<TreeViewProvider
				fetchFolderLayer={({ folderId, page, perPage }) => {
					return instanceApi(FolderApi).getFolderTreeView(folderId, perPage, page);
				}}
				fetchRootLayer={({ page, perPage }) => {
					return instanceApi(FolderApi)
						.getFolders(transformToStringFrom({ ...defaultQueryFilter, order: "asc", orderBy: "name", page, perPage }))
						.then((data) => ({
							...data,
							data: data.data.map<TreeViewListItemType>((item) => ({
								...item,
								isFolder: true,
								companyId: item.owner?.companyId ?? "",
							})),
						}));
				}}
				rootFolderId="picker"
				ignoreQueryParams
			>
				<TreeViewList ListItemComponent={PickerListItem} hideHeader ItemSize={42} />
			</TreeViewProvider>
			<DocumentPreviewModal id="document-preview-modal" shouldRestoreDocument={false} />
		</>
	);
}
